// ============================================================
// FYUNOR — Region / State Configuration
// Sub-country regions (states, provinces). Architecture only.
// ============================================================

/**
 * RegionConfig shape:
 * { code, name, country, taxAuthority?, references?[] }
 */
export function defineRegion(config) {
  return Object.freeze({ references: [], ...config });
}

const _regions = new Map();

export function registerRegion(region) {
  const key = `${region.country}:${region.code}`;
  _regions.set(key, defineRegion(region));
}

export function getRegion(countryCode, regionCode) {
  return _regions.get(`${countryCode?.toUpperCase()}:${regionCode?.toUpperCase()}`) || null;
}

export function listRegions(countryCode) {
  return Array.from(_regions.values()).filter((r) => r.country === countryCode?.toUpperCase());
}

// ---- Seed a few US states to demonstrate the pattern (Phase 2 expands) ----
registerRegion({ code: "CA", name: "California", country: "US", taxAuthority: "FTB" });
registerRegion({ code: "NY", name: "New York", country: "US", taxAuthority: "NYS DTF" });
registerRegion({ code: "TX", name: "Texas", country: "US", taxAuthority: "Texas Comptroller" });

export function isSupportedRegion(countryCode, regionCode) {
  return Boolean(getRegion(countryCode, regionCode));
}